module.exports = __webpack_public_path__ + "media/images/front/event/wordSearch-icon-f0ec5d3a2412f55cd9e6209a2e85e534.svg";